import React from 'react';

export const HeroSection = ({
  user,
  gallery,
  activeGallery,
  setActiveGallery,
  onGoToDashboard,
  onViewProjects
}) => {
  return (
    <section className="relative rounded-3xl min-h-[440px] md:min-h-[500px] flex items-end overflow-hidden shadow-xl border border-[#ECE7DE] mb-10">
      {/* Background slideshow */}
      {gallery.map((item, i) => (
        <div
          key={item.id}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === activeGallery ? 1 : 0 }}
        >
          <img
            src={require(`../../../assets/Images/${item.id}.jpg`)}
            alt={item.label}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      {/* Dark gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/25 to-transparent" />

      {/* Hero Content */}
      <div className="relative z-10 w-full px-8 md:px-12 pb-10 md:pb-12 pt-16">
        <div className="max-w-2xl">
          <p className="text-[11px] font-bold tracking-[0.25em] text-[#C99B63] uppercase mb-3 font-sans">
            Admin Portal
          </p>
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white leading-[1.15] tracking-tight mb-4 drop-shadow-md">
            Welcome Back,<br />
            <span className="italic font-normal text-white/95">{user?.name || 'Space Designs Owner'}</span>
          </h1>
          <p className="text-slate-200 text-base md:text-lg leading-relaxed mb-6 max-w-lg font-sans font-normal opacity-90">
            Manage your Sales, Inventory, Accounting, Projects, Team, and Operations from one centralized Portal.
          </p>
        </div>

        {/* Gallery dots indicator */}
        <div className="flex items-center gap-2 mt-4">
          {gallery.map((item, i) => (
            <button
              key={i}
              onClick={() => setActiveGallery(i)}
              className={`transition-all duration-300 rounded-full ${i === activeGallery ? 'w-8 h-2.5 bg-[#C91D25]' : 'w-2.5 h-2.5 bg-white/50 hover:bg-white/80'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};




